import {
  NewButton,
  NewButtonSize,
  NewButtonVariant,
} from "@visiblethread/react-components";
import Flex from "components/Flex";
import { modalTypes } from "constants/types";
import useOpenDocumentEditor from "hooks/proposalOutline/useOpenDocumentEditor";
import { PenLine } from "lucide-react";
import { number, shape } from "prop-types";
import { useDispatch, useSelector } from "react-redux";
import { hideModal, showModal } from "slices/app/actions/modals";
import {
  detachAndStartWriting,
  startWriting,
} from "slices/proposalOutline/actions/documentActions";
import {
  selectOutlineOwner,
  selectProposalOutlineSections,
} from "slices/proposalOutline/selectors";
import { getChildOutlineSectionsByIndex } from "utils/proposals";

import classes from "./StartWritingButton.module.scss";

const modalType = modalTypes.START_WRITING_PROPOSAL_OUTLINE_WIZARD;

const StartWritingButton = ({ row }) => {
  const dispatch = useDispatch();
  const owner = useSelector(selectOutlineOwner);
  const sections = useSelector(selectProposalOutlineSections);
  const openDocumentEditor = useOpenDocumentEditor();

  const { index } = row;
  const { id: outlineId } = row.original;

  const onConfirmStart = async (source, templateId) => {
    if (!owner) {
      return;
    }

    const { ownerType, ownerId } = owner;
    const rsp = await dispatch(
      startWriting(ownerType, ownerId, outlineId, source)
    );
    openDocumentEditor(rsp, { modalType, source, templateId });
  };

  const onResolveConflicts = async (params) => {
    const { source, templateId } = params;
    dispatch(hideModal(modalTypes.START_WRITING_PROPOSAL_OUTLINE_WIZARD));

    if (!owner) {
      return;
    }

    const { ownerType, ownerId } = owner;
    const rsp = await dispatch(
      detachAndStartWriting(ownerType, ownerId, outlineId, params)
    );
    openDocumentEditor(rsp, { modalType, source, templateId });
  };

  const onClickStartWriting = (e) => {
    e.stopPropagation();
    const childSections = getChildOutlineSectionsByIndex(sections, index);
    const hasConflicts = childSections.some((s) => s.nextgenDocumentId);

    dispatch(
      showModal(modalTypes.START_WRITING_PROPOSAL_OUTLINE_WIZARD, {
        childSections,
        hasConflicts,
        onConfirmStart,
        onResolveConflicts,
      })
    );
  };

  return (
    <Flex
      className={classes.start_writing_flex}
      data-show-on-row-hover
      justifyContent="flex-end"
    >
      <NewButton
        data-testid="start-writing-button"
        variant={NewButtonVariant.l1}
        size={NewButtonSize.sm}
        onClick={onClickStartWriting}
        leftIcon={<PenLine size={14} />}
      >
        Start Writing
      </NewButton>
    </Flex>
  );
};

StartWritingButton.propTypes = {
  row: shape({
    index: number,
    original: shape({}).isRequired,
  }).isRequired,
};

export default StartWritingButton;
